export default "__VITE_ASSET__BYnsxm5J__"